import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import { connect } from 'react-redux';
import NativeTable from '../../components/NativeTable/NativeTable';

import { Popover, PopoverBody, PopoverHeader, Alert } from 'reactstrap';

import {
    Button,
    ButtonToolbar,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from "reactstrap";

import s from './UsersList.module.scss';

import { loadStoreDetails } from '../../actions/settings';
import { setRoleId, getUsersRequest, deleteUserRequest, updateUserRequest, createUserRequest, setSelectedEmployee } from '../../actions/users';
import { mockUser } from '../../model/mockUser';
import {
    getStripeAccountStatusRequest,
    disconnectStripeAccountRequest,
    getStripeDashboardLinkRequest,
    getStripeAccountUpdateLinkRequest,
    toggleTipPayoutRequest,
    sendOnboardingLinkEmailRequest,
    sendOnboardingLinkSmsRequest,
    linkExistingStripeAccountRequest
} from '../../actions/stripe';

import Loader from '../../components/Loader';
import Widget from '../../components/Widget';
import StripeConnectBadge from '../../components/StripeConnect';
import { withTranslation } from '../../i18n/LanguageContext';

class UsersList extends React.Component {

    static propTypes = {
        users: PropTypes.array,
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        users: []
    };

    state = {
        popovers: {},
        promoAlert: false,
        isAddModal: false,
        curUser: mockUser,
        selectedRole: 1,
        userError: "",
        pinError: ""
    };

    constructor(props) {
        super(props);

        this.changeUsername = this.changeUsername.bind(this);
        this.changePhone = this.changePhone.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.changePin = this.changePin.bind(this);
        this.changeRole = this.changeRole.bind(this);
    }

    changeUsername(event) {
        var user = this.state.curUser;
        user.Username = event.target.value;
        this.setState({ curUser: user });
    }

    changePhone(event) {
        var user = this.state.curUser;
        user.Telephone = event.target.value;
        this.setState({ curUser: user });
    }

    changeEmail(event) {
        var user = this.state.curUser;
        user.Email = event.target.value;
        this.setState({ curUser: user });
    }

    changePin(event) {
        const raw = event.target.value.replace(/\D/g, "").slice(0, 4);
        var user = this.state.curUser;
        user.Pin = raw;

        let pinError = "";
        if (raw.length > 0 && raw[0] === "0") {
            pinError = "PIN cannot start with 0.";
        } else if (raw.length > 0 && raw.length < 4) {
            pinError = "PIN must be exactly 4 digits.";
        }

        this.setState({ curUser: user, pinError });
    }

    changeRole(event) {
        this.setState({ selectedRole: event.target.value });
    }

    loadUsers = () => {
        if (!this.props.merchant?.MerchantId) {
            return;
        }
        // Reload when empty or when the previous attempt left an error.
        if (this.props.users.length < 1 || this.props.usersError) {
            this.props.dispatch(getUsersRequest(this.props.merchant.MerchantId));
        }
    }

    componentDidMount() {
        this.loadUsers();

        if (this.props.merchant?.MerchantId && this.props.storeSettingsMerchantId !== this.props.merchant.MerchantId) {
            this.props.dispatch(loadStoreDetails());
        }

        // Check for Stripe onboarding return via URL params
        const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
        const stripeReturn = urlParams.get('stripe_return');
        const stripeUserId = urlParams.get('userId');
        if (stripeReturn && stripeUserId) {
            this.props.dispatch(getStripeAccountStatusRequest(parseInt(stripeUserId)));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.merchant?.MerchantId !== this.props.merchant?.MerchantId) {
            this.loadUsers();
        }
    }

    showPromoAlert = () => {
        this.setState({promoAlert: true});
    }

    showAddModal = () => {
        this.setState({isAddModal: true});
    }

    hideAddModal = (e) => {
        e.preventDefault();

        this.setState({...this.state, isAddModal: false});
    }

    onClickRole = (e, role_id) => {
        e.preventDefault();
    
        this.props.dispatch(setRoleId(role_id));
    }

    createNewUser = (e) => {
        e.preventDefault();

        const {curUser} = this.state;

        var userError = "";
        if (curUser.Username == "") {
            userError = "Please input name";
        } else if (curUser.Telephone == "") {
            userError = "Please input phone number";
        } else if (curUser.Email == "") {
            userError = "Please input email address";
        } else if (curUser.Pin == "" || curUser.Pin == null) {
            userError = "Please input a PIN number.";
        } else if (String(curUser.Pin)[0] === "0") {
            userError = "PIN cannot start with 0.";
        } else if (!/^\d{4}$/.test(String(curUser.Pin))) {
            userError = "PIN must be exactly 4 digits (numbers only).";
        } else if (curUser.Roles.length < 1) {
            userError = "Please add role";
        } else if (curUser.ReceivesHourlyWage) {
            const rate = Number(curUser.HourlyRate);
            if (!Number.isFinite(rate) || rate <= 0) {
                userError = "Hourly rate is required when hourly wage is enabled.";
            }
        }

        if (userError == "") {
            if (curUser.UserId == 0) {
                this.props.dispatch(createUserRequest(curUser));
            } else {
                this.props.dispatch(updateUserRequest(curUser));
            }
            this.setState({isAddModal: false});
        } else {
            this.setState({userError: userError});
        }
    }

    editUser = (id) => {
        const {curRoleId} = this.props;
        
        const user = this.getUserById(id);
        this.setState({isAddModal: true, selectedRole: curRoleId, curUser: user});

        // Auto-refresh Stripe status when opening user drawer
        if (user.UserId) {
            this.props.dispatch(getStripeAccountStatusRequest(user.UserId));
        }
    }

    getUserById = (id) => {
        const {users, merchant} = this.props;
        var data = users.filter(function( u ) {
            return u.UserId == id;
        });

        var user = { ...mockUser };
        if (data.length > 0) {
            const row = data[0];
            user = {
                ...mockUser,
                ...row,
                ReceivesHourlyWage: !!(row.ReceivesHourlyWage ?? row.receivesHourlyWage),
                HourlyRate: row.HourlyRate ?? row.hourlyRate ?? null,
                IncludeTipsAndGratuityInPayroll: row.IncludeTipsAndGratuityInPayroll !== undefined
                    ? row.IncludeTipsAndGratuityInPayroll
                    : (row.includeTipsAndGratuityInPayroll !== undefined
                        ? row.includeTipsAndGratuityInPayroll
                        : null),
            };
        } else {
            user.MerchantId = merchant.MerchantId;
        }
        return user;
    }

    changeReceivesHourlyWage = (event) => {
        const checked = !!(event?.target?.checked);
        this.setState((prev) => ({
            curUser: {
                ...prev.curUser,
                ReceivesHourlyWage: checked,
                HourlyRate: checked ? prev.curUser.HourlyRate : null,
            },
            userError: '',
        }));
    };

    changeHourlyRate = (event) => {
        const value = event.target.value;
        this.setState((prev) => ({
            curUser: {
                ...prev.curUser,
                HourlyRate: value === '' ? null : value,
            },
            userError: '',
        }));
    };

    changeTipsInPayrollOverride = (event) => {
        const value = event.target.value;
        let override = null;
        if (value === 'true') override = true;
        if (value === 'false') override = false;
        this.setState((prev) => ({
            curUser: {
                ...prev.curUser,
                IncludeTipsAndGratuityInPayroll: override,
            },
            userError: '',
        }));
    };

    deleteUser = (id) => {
        this.togglePopover(id);
        this.props.dispatch(deleteUserRequest(id));
    }

    addUserRole = (e) => {
        e.preventDefault();
        var user = this.state.curUser;
        var selectedRole = this.state.selectedRole * 1;

        var userRoles = user.Roles.filter(function( r ) {
            return r == selectedRole;
        });

        if (userRoles.length < 1) {
            user.Roles.push(selectedRole);
        }
        
        this.setState({ curUser: user });
    }

    deleteUserRole = (e) => {
        e.preventDefault();
        var user = this.state.curUser;
        var selectedRole = this.state.selectedRole;

        const userRoles = user.Roles.filter(function( r ) {
            return r != selectedRole;
        });

        user.Roles = userRoles;

        this.setState({ curUser: user });
    }

    togglePopover(id) {
        let newState = {...this.state};
        if (!this.state.popovers[id]) {
            newState.popovers[id] = true;
        } else {
            newState.popovers[id] = !newState.popovers[id];
        }
        this.setState(newState);
    }

    stripeStatusFormatter = (cell, row) => {
        const account = this.props.stripeAccounts[row.UserId] || {
            stripeAccountId: row.StripeAccountId,
            stripeAccountStatus: row.StripeAccountStatus,
            tipPayoutEnabled: row.TipPayoutEnabled,
        };
        if (!account) {
            return <span className="text-muted" style={{fontSize: '0.8rem'}}>—</span>;
        }
        const status = account.stripeAccountStatus;
        const colors = {
            active: '#28a745',
            pending: '#ffc107',
            pending_verification: '#ffc107',
            onboarding_incomplete: '#ffc107',
            restricted: '#dc3545',
            disabled: '#6c757d'
        };
        let label = account.tipPayoutEnabled && status === 'active' ? '● Tips On' : (status || '—');

        if (account.accountLinkSource === 'linked_existing') {
            label += ' · Existing';
        }

        const tipsOnTitle = account.tipPayoutEnabled && status === 'active'
            ? 'Tips On: sale-time tips go to this employee. Designated manager is used only if Stripe is not correctly configured.'
            : undefined;

        return (
            <span
                style={{ color: colors[status] || '#999', fontSize: '0.8rem', fontWeight: 600 }}
                title={tipsOnTitle}
            >
                {label}
            </span>
        );
    }

    nameFormatter = (cell, row) => {
        return (
            <Link 
                to={`/admin/users/sales/${row.UserId}`}
                className={s.employeeLink}
                onClick={() => this.props.dispatch(setSelectedEmployee(row))}
            >
                {cell}
            </Link>
        );
    }

    apiFormatter = (cell, row) => {
        return (
            <ButtonToolbar className="">
                <button id={'popoverDelete_' + row.UserId} className="btn">
                    {this.props.isDeleting && this.props.idToDelete === row.UserId ? <Loader size={14}/> :
                        <div><i className="zmdi zmdi-delete"></i></div>
                    }
                </button>
                <button className="btn" onClick={()=> this.editUser(row.UserId)}>
                    <div><i className="zmdi zmdi-edit"></i></div>
                </button>
                
                <Popover className="popover-danger" target={'popoverDelete_' + row.UserId} placement="top" isOpen={this.state.popovers[row.UserId]}
                         toggle={()=>{this.togglePopover(row.UserId)}}
                >
                    <PopoverHeader className="px-5">{this.props.t('common.confirm')}</PopoverHeader>
                    <PopoverBody className="px-5 d-flex justify-content-center">
                        <ButtonToolbar>
                            <Button color="success" size="xs" onClick={() => {this.deleteUser(row.UserId)}}>
                                {this.props.t('common.yes')}
                            </Button>
                            <Button color="danger" size="xs" onClick={() => {this.togglePopover(row.UserId)}}>
                                {this.props.t('common.no')}
                            </Button>
                        </ButtonToolbar>
                    </PopoverBody>
                </Popover>
            </ButtonToolbar>
        )
    }

    renderSizePerPageDropDown = (props) => {
        const limits = [];
        props.sizePerPageList.forEach((limit) => {
            limits.push(<DropdownItem key={limit}
                                      onClick={() => props.changeSizePerPage(limit)}>{limit}</DropdownItem>);
        });

        return (
            <Dropdown isOpen={props.open} toggle={props.toggleDropDown}>
                <DropdownToggle color="default" caret>
                    {props.currSizePerPage}
                </DropdownToggle>
                <DropdownMenu>
                    {limits}
                </DropdownMenu>
            </Dropdown>
        );
    };

    getUsers = () => {
        const {curRoleId, users} = this.props;
        const list = Array.isArray(users) ? users : [];

        var data = list.filter(function( u ) {
            const roleIds = Array.isArray(u?.Roles)
                ? u.Roles
                : (Array.isArray(u?.roles) ? u.roles : []);
            for (var i = 0; i < roleIds.length; i++) {
                if (roleIds[i] == curRoleId) {
                    return true;
                }
            }
            return false;
        });

        return data;
    }

    getUserRoles = (roleIds) => {
        const {roles} = this.props;

        var data = roles.filter(function( r ) {
            for (var i = 0; i < roleIds.length; i++) {
                if (roleIds[i] == r.Id) {
                    return true;
                }
            }
            return false;
        });

        var userRoles = [];
        for (var i = 0; i< data.length; i++) {
            userRoles.push(data[i].Name);
        }
        
        return userRoles.join(", ");
    }

    render() {
        const options = {
            sizePerPage: 10,
            paginationSize: 3,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
        };

        const data = this.getUsers();//this.props.users;//this.getUsers();
        const {roles, curRoleId, isReceiving, isUpdating, isDeleting, usersError} = this.props;
        const tipPayoutsDisabled = Number(this.props.tipPayoutRoutingMode) === 3;
        
        const {isAddModal, curUser, selectedRole, userError} = this.state;
        const userRoles = this.getUserRoles(curUser.Roles);

        return (
            <div className="page-wrapper">
                <div className="page-tabs page-tabs--scrollable">
                    {(Array.isArray(roles) ? roles : []).map((role, i) => 
                        <a 
                            href="#" 
                            className={`page-tab ${curRoleId == role.Id ? 'page-tab--active' : ''}`} 
                            key={role.Id}
                            onClick={(e) => this.onClickRole(e, role.Id)}>
                                <span>{role.Name}</span>
                        </a>
                    )}
                </div>
                <div className="page-content">
                    {
                        isReceiving || isUpdating || isDeleting ? (<Loader size={80}/>) : (<div></div>)
                    }
                    <div className="tab_header">
                        <h1>
                            <span className="d-block">{this.props.t('usersChrome.people')}</span>
                        </h1>
                        <button type="button" className="btn" onClick={()=> this.editUser(0)}>{this.props.t('common.add')}</button>
                    </div>
                    {usersError ? (
                        <Alert className="alert-sm mx-3" color="danger">
                            {usersError}
                        </Alert>
                    ) : null}
                    <Widget>
                        <div className="order_list">
                            <NativeTable
                                data={data}
                                searchFields={['Username', 'Email', 'Telephone']}
                                columns={[
                                    { key: 'UserId', header: this.props.t('usersChrome.id'), hideMobile: true },
                                    { key: 'Username', header: this.props.t('usersChrome.name'), render: (cell, row) => this.nameFormatter(cell, row) },
                                    { key: 'Telephone', header: this.props.t('usersChrome.phoneShort'), hideMobile: true },
                                    { key: 'Email', header: this.props.t('usersChrome.email') },
                                    { key: 'createdAt', header: this.props.t('usersChrome.created'), hideMobile: true },
                                    { key: 'UserId', header: this.props.t('usersChrome.tips'), render: (cell, row) => this.stripeStatusFormatter(cell, row), hideMobile: true },
                                    { key: 'UserId', header: this.props.t('common.action'), render: (cell, row) => this.apiFormatter(cell, row) },
                                ]}
                            />
                        </div>
                        <Drawer anchor="right" open={isAddModal} onClose={this.hideAddModal}>
                            <div className="add_category_model add_expenses receipt_model px-0" 
                                id="add_expenses" tabIndex="-1" role="dialog" aria-labelledby="receipt_modelTitle" aria-modal="true">
                                <div className="modal-dialog modal-dialog-scrollable" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header px-0">
                                            <h2 className="col-10 mx-auto">{curUser.UserId == 0 ? this.props.t('usersChrome.addPeople') : this.props.t('usersChrome.editPeople')}</h2>
                                        </div>
                                        <div className="row alert-container">
                                        {
                                            userError && (
                                                <Alert className="alert-sm" color="danger">
                                                    {userError}
                                                </Alert>
                                            )
                                        }
                                        </div>
                                        <div className="modal-body p-0">
                                            <form>
                                                <div className="col-10 mx-auto form_container">
                                                    <div className="form-group">
                                                        <label>{this.props.t('usersChrome.name')}</label>
                                                        <input type="text" className="form-control" value={curUser.Username} onChange={this.changeUsername}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>{this.props.t('usersChrome.phone')}</label>
                                                        <input type="text" className="form-control" value={curUser.Telephone == null ? "" : curUser.Telephone} onChange={this.changePhone}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>{this.props.t('usersChrome.email')}</label>
                                                        <input type="email" className="form-control" value={curUser.Email == null ? "" : curUser.Email} onChange={this.changeEmail}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>{this.props.t('usersChrome.pin')}</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control${this.state.pinError ? " is-invalid" : (curUser.Pin && String(curUser.Pin).length === 4 ? " is-valid" : "")}`}
                                                            value={curUser.Pin == null ? "" : curUser.Pin}
                                                            onChange={this.changePin}
                                                            maxLength={4}
                                                            inputMode="numeric"
                                                            placeholder={this.props.t('usersChrome.pinPlaceholder')}
                                                        />
                                                        {this.state.pinError ? (
                                                            <small className="text-danger">{this.state.pinError}</small>
                                                        ) : (
                                                            <small className="text-muted">{this.props.t('usersChrome.pinHelp')}</small>
                                                        )}
                                                    </div>
                                                    <div className="form-group">
                                                        <label>{this.props.t('usersChrome.roleType')}</label>
                                                        <select className="form-control" value={selectedRole} onChange={this.changeRole}>
                                                        {roles.map((role, i) => 
                                                            <option value={role.Id} key={role.Id}>{role.Name}</option>
                                                        )}
                                                        </select>
                                                    </div>
                                                    <div className="form-group role-button-group">
                                                        <button className="btn Cencel" onClick={(e) => this.deleteUserRole(e)}>{this.props.t('common.delete')}</button>
                                                        <button className="btn Cencel" onClick={(e) => this.addUserRole(e)}>{this.props.t('common.add')}</button>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>{this.props.t('usersChrome.role')}</label>
                                                        <input type="text" className="form-control" value={userRoles} readOnly/>
                                                    </div>

                                                    <div className="form-group" style={{borderTop: '1px solid #eee', paddingTop: '15px', marginTop: '10px'}}>
                                                        <label className="d-block mb-2">{this.props.t('usersChrome.payroll')}</label>
                                                        <div className="custom-control custom-switch mb-2">
                                                            <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id="receivesHourlyWage"
                                                                checked={!!curUser.ReceivesHourlyWage}
                                                                onChange={this.changeReceivesHourlyWage}
                                                            />
                                                            <label className="custom-control-label" htmlFor="receivesHourlyWage">
                                                                {this.props.t('usersChrome.receivesHourlyWage')}
                                                            </label>
                                                        </div>
                                                        {curUser.ReceivesHourlyWage ? (
                                                            <div className="form-group mb-2">
                                                                <label>{this.props.t('usersChrome.hourlyRate')}</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    inputMode="decimal"
                                                                    placeholder="0.00"
                                                                    value={curUser.HourlyRate == null ? '' : curUser.HourlyRate}
                                                                    onChange={this.changeHourlyRate}
                                                                />
                                                                <small className="text-muted">{this.props.t('usersChrome.hourlyRequired')}</small>
                                                            </div>
                                                        ) : (
                                                            <p className="text-muted mb-2" style={{fontSize: '0.85rem'}}>
                                                                {this.props.t('usersChrome.nonHourlyHelp')}
                                                            </p>
                                                        )}
                                                        <div className="form-group mb-0">
                                                            <label>{this.props.t('usersChrome.tipsInPayroll')}</label>
                                                            <select
                                                                className="form-control"
                                                                value={
                                                                    curUser.IncludeTipsAndGratuityInPayroll === true
                                                                        ? 'true'
                                                                        : (curUser.IncludeTipsAndGratuityInPayroll === false
                                                                            ? 'false'
                                                                            : 'inherit')
                                                                }
                                                                onChange={this.changeTipsInPayrollOverride}
                                                            >
                                                                <option value="inherit">{this.props.t('usersChrome.inheritDefault')}</option>
                                                                <option value="true">{this.props.t('usersChrome.alwaysInclude')}</option>
                                                                <option value="false">{this.props.t('usersChrome.neverInclude')}</option>
                                                            </select>
                                                            <small className="text-muted">
                                                                {this.props.t('usersChrome.merchantDefaultHelp')}
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <div className="form-group" style={{borderTop: '1px solid #eee', paddingTop: '15px', marginTop: '10px'}}>
                                                        {curUser.UserId === 0 ? (
                                                            <div className="stripe-connect-section">
                                                                <label className="d-block mb-2">{this.props.t('usersChrome.stripeTips')}</label>
                                                                <p className="text-muted mb-0" style={{fontSize: '0.85rem'}}>
                                                                    {tipPayoutsDisabled
                                                                        ? this.props.t('usersChrome.stripeDisabled')
                                                                        : this.props.t('usersChrome.stripeAfterCreate')}
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            <StripeConnectBadge
                                                                user={curUser}
                                                                stripeAccount={this.props.stripeAccounts[curUser.UserId] || null}
                                                                isConnecting={this.props.stripeConnecting && this.props.stripeConnectingUserId === curUser.UserId}
                                                                merchantId={this.props.merchant.MerchantId}
                                                                tipPayoutRoutingMode={this.props.tipPayoutRoutingMode}
                                                                onDisconnect={(userId) => this.props.dispatch(disconnectStripeAccountRequest(userId))}
                                                                onRefreshStatus={(userId) => this.props.dispatch(getStripeAccountStatusRequest(userId))}
                                                                onViewDashboard={(userId) => this.props.dispatch(getStripeDashboardLinkRequest(userId))}
                                                                onFixOnStripe={(userId) => this.props.dispatch(getStripeAccountUpdateLinkRequest(userId))}
                                                                onTogglePayout={(userId, enabled) => this.props.dispatch(toggleTipPayoutRequest(userId, enabled))}
                                                                onSendEmail={(userId, merchantId, email, username) => this.props.dispatch(sendOnboardingLinkEmailRequest(userId, merchantId, email, username))}
                                                                onSendSms={(userId, merchantId, phone, username) => this.props.dispatch(sendOnboardingLinkSmsRequest(userId, merchantId, phone, username))}
                                                                onLinkExisting={(userId, stripeAccountId) => this.props.dispatch(linkExistingStripeAccountRequest(userId, stripeAccountId))}
                                                            />
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="modal-footer">
                                                    <div className="row no-gutters w-100">
                                                        <div className="col-6"> <button className="btn Cencel" onClick={(e) => this.hideAddModal(e)}>{this.props.t('common.cancel')}</button></div>
                                                        <div className="col-6"> <button className="btn" onClick={(e) => this.createNewUser(e)}>{curUser.UserId == 0 ? this.props.t('common.add') : this.props.t('common.update')}</button></div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Drawer>
                    </Widget>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        users: state.users.data,
        roles: state.users.roles,
        curRoleId: state.users.curRoleId,
        isReceiving: state.users.isReceiving,
        isUpdating: state.users.isUpdating,
        isDeleting: state.users.isDeleting,
        idToDelete: state.users.idToDelete,
        usersError: state.users.error,
        merchant: state.auth.merchant,
        tipPayoutRoutingMode: state.settings.storeDetails?.TipPayoutRoutingMode || state.auth.merchant?.TipPayoutRoutingMode || 3,
        storeSettingsMerchantId: state.settings.storeDetails?.MerchantId || 0,
        // Stripe Connect state
        stripeAccounts: state.stripe.accounts,
        stripeConnecting: state.stripe.isConnecting,
        stripeConnectingUserId: state.stripe.connectingUserId,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(UsersList)));

